import {Component, Input} from "@angular/core";
import {AuthService} from "../../../../../services/auth.service";
import {RootShareService} from "../../../../../services/root.shared.service";
import {OpticNerveHead} from "../../../../../models/forms/referral/optic.nerve.head";

@Component({
    selector: 'optic-nerve-head-component',
    templateUrl: './optic.nerve.head.html'
})
export class OpticNerveHeadComponent {
    @Input() opticNerveHead: OpticNerveHead;

    @Input() patient: any;
    @Input() patientDocument: any;
    @Input() readOnly: Boolean = false;

    constructor(private _rootShareService: RootShareService, private _auth: AuthService) {
    }
}
